import {Component, OnInit, ViewEncapsulation} from '@angular/core';

export interface ExperienceData {
    title:string;
    company:string;
    duties:string;
    startDate:string;
    endDate:string;
}

@Component({
    selector: 'app-experience',
    templateUrl: './experience.component.html',
    styleUrls: ['./experience.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ExperienceComponent implements OnInit {

    public experienceArr:ExperienceData[] = [
        {
            title: "Analyst, User Services",
            company: "PSP Investments",
            duties: "Maintenanced the tickets for clients using the Service Now application. "+ 
                    "Configured the BIOS using BIOS Utility of any type of computer. " +
                    "Transferred data of softwares using USMT (User State Migration Tool). " +
                    "Initialized permissions to users using Active directory (tool to add, edit or remove users from system). " + 
                    "Configured mobile software using Mitel & Micolab (Application for communication across an organization). " +
                    " Deployed and managed server applications using SCCM (System Center Configuration Manager Tool). " +
                    "Configured network ports using PuTTY (File transfer application).",
            startDate: "May 2019",
            endDate: "August 2019"
        },
        {
            title: "Software Developer",
            company: "Kronos Incorporated",
            duties: "Automated dashboards and excel data entry with MERN stack (React.JS, Node.JS, Express.JS and mySQL). Operated the database with mySQL platform.",
            startDate: "September 2018",
            endDate: "December 2018"
        },
        {
            title: "Web Developer",
            company: "Mezoweb",
            duties: "Implemented Google and Facebook login functionalities on web-based software applications with PHP. Operated with HTML, CSS and javascript for webpage content.",
            startDate: "January 2017",
            endDate: "May 2017"
        },
        {
            title: "Game Tester",
            company: "Volt",
            duties: "Able to identify bugs and glitches in a variety of games. Adapt to different styles of games. (Fighting, shooting and board games)",
            startDate: "May 2015",
            endDate: "August 2016"
        },
    ];

    constructor() {
    }

    ngOnInit() {
    }

}
